// extracted by mini-css-extract-plugin
module.exports = {"root":"MonthRangeSwitch_root__3k5pp","range":"MonthRangeSwitch_range__36RQy","disabled":"MonthRangeSwitch_disabled__18PNi"};